function buildSvgDataUrl(svg) {
  const encoded = encodeURIComponent(svg)
    .replace(/'/g, '%27')
    .replace(/"/g, '%22');

  return `data:image/svg+xml,${encoded}`;
}

export function iconCircularButtonArrow(radius, angle, arrowColor = '#000000') {
  const size = radius * 1.5;
  const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 612 612">
      <g transform="rotate(${angle}, 306, 306)">
        <circle cx="306" cy="306" r="286.875" fill="none" stroke="#000000" stroke-width="38.25"/>
        <path fill="${arrowColor}" stroke="${arrowColor}" stroke-width="18" stroke-linejoin="round" d="M322.811 180.999c-4.59-4.571-10.882-6.005-16.811-4.953-5.929-1.052-12.221.382-16.811 4.953l-108.19 108.19c-7.478 7.478-7.478 19.584 0 27.042 7.478 7.479 19.584 7.479 27.043 0l78.833-78.813v202.457c0 10.557 8.568 19.125 19.125 19.125s19.125-8.568 19.125-19.125V237.418l78.814 78.813c7.478 7.479 19.584 7.479 27.042 0 7.479-7.478 7.479-19.583 0-27.042l-108.17-108.19z"/>
      </g>
    </svg>
  `.trim();

  return buildSvgDataUrl(svg);
}

export function iconCircularButtonCalm(radius, dotColor = '#000000') {
  const size = radius * 1.5;
  const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 612 612">
      <circle cx="306" cy="306" r="286.875" fill="none" stroke="#000000" stroke-width="38.25"/>
      <circle cx="306" cy="306" r="85" fill="${dotColor}"/>
    </svg>
  `.trim();

  return buildSvgDataUrl(svg);
}
